var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.client_config.client_id
    ? _c("login-layout", { style: _vm.brandColours }, [
        _c("form", { staticClass: "t-login__form" }, [
          _c(
            "div",
            { staticClass: "t-login__field" },
            [
              _c(
                "label",
                { staticClass: "control-label", attrs: { for: "email" } },
                [_vm._v("Email:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.$v.email.$model,
                    expression: "$v.email.$model",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  id: "email",
                  type: "email",
                  name: "email",
                  autofocus: "",
                },
                domProps: { value: _vm.$v.email.$model },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.$v.email, "$model", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("vuelidate-help", {
                attrs: { label: "Email", field: _vm.$v.email },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "t-login__field" },
            [
              _c(
                "label",
                { staticClass: "control-label", attrs: { for: "password" } },
                [_vm._v("Password:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.$v.password.$model,
                    expression: "$v.password.$model",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "password", type: "password", name: "password" },
                domProps: { value: _vm.$v.password.$model },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.$v.password, "$model", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("vuelidate-help", {
                attrs: { label: "Password", field: _vm.$v.password },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center" },
            [
              _c(
                "ladda-button",
                {
                  ref: "search",
                  staticClass: "btn btn-dark",
                  attrs: { type: "submit", click: _vm.handleLoginCallback },
                },
                [_vm._v("\n        Login\n      ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  ref: "back",
                  staticClass: "reset-link",
                  attrs: {
                    to: "/reset-password",
                    tag: "button",
                    type: "button",
                  },
                },
                [_vm._v("\n        Forgot your password?\n      ")]
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }